const endpoints = {
  transmissions: "/v2/transmissions",
  transmission: {
    list: "/v2/transmission",
    bulkDownload: "bulk-download",
    signReports: "clinic/sign-reports",
    unsignReports: "/v2/transmission/unsign-reports",
    billReports: "clinic/bill-reports",
    reportBanners: "/v2/report-banners",
    clinicNotes: "clinic-notes",
    patientMRN: "/patient/mrn",
    reportNotes: "/v2/transmission/report-notes",
    diagnosisCodes: "/v2/transmission/diagnosis-codes",
    patientNotes: "/v2/transmissions/clinician-notes",
    updateTransmissionReport:
      "/v2/transmission/update-transmission-report/:reportId",
    archiveReports: "/v2/transmission/archive-reports",
    unarchiveReports: "/v2/transmission/unarchive-reports",
    ehrNotes: "/v2/transmission/ehr-notes/:reportId",
    updateAuditStatus: "/v2/transmission/audit-status/:reportId",
    saveChfScreeningNotes: "/v2/transmissions/rn-chf-screening-notes",
    quickTextOptions: "/v2/transmission/quick-text-options",
    clinicNoteWithText: "/v2/transmission/:reportId/clinic-note",
    providerNote: "/v2/transmission/:reportId/provider-note",
    addNoteComment: "/v2/report-notes/:reportId/contents/:contentId/comments",
    updateNoteComment:
      "/v2/report-notes/:reportId/contents/:contentId/comments/:commentId",
    assignPhysicianToReport: "/v2/transmission/:reportId/assign-physician",
  },

  reportTemplates: {
    getAll: "/v2/report-templates",
    getById: "/v2/report-templates/:id",
    selectors: "/v2/report-templates/selectors",
    getByReportInformation: "/v2/report-templates/report-information",
  },
  reportNoteSections: {
    get: "/v2/report-note-sections",
    getById: "/v2/report-note-sections/:id",
  },
  reportNoteSuggestions: {
    getByReportId: "/v2/report-note-suggestions/:reportId",
  },
  deviceGroups: {
    getAll: "/v2/device-groups",
    getById: "/v2/device-groups/:id",
    selectors: "/v2/device-groups/selectors",
  },
  devices: {
    device: "/v2/device",
    deviceById: "/v2/device/:id",
    alertList: "/v2/device/alert-list",
  },
  previousAlerts: "/v2/transmissions/alerts/:reportId",
  previousReports: "/v2/transmissions/previousReports/:reportId",
  reportBanners: "/v2/report-banners/:serialNumber",
  physicians: {
    list: "/patient/physicians",
    update: "/patient/information/physicians",
    referringProviders: "/v2/referring-providers",
    referringProvidersById: "/v2/referring-providers/:id",
  },
  hospitals: {
    list: "/v2/hospital",
  },
  insurances: {
    insurances: "/v2/insurances",
    insurancesById: "/v2/insurances/:id",
    benchmarkInsurances: "/v2/insurances/benchmark",
  },
  patient: {
    list: "/v2/patient/list",
    downloadList: "/v2/patient/download-list",
    enroll: "/v2/patient/enroll",
    updateActive: "/v2/patient/update-active/:patientId",
    billingHistoryV2: "/v2/patient/billing-history/:reportId",
    billingHistory: "/patient/billing-history/:serial_number",
    profile: "/v2/patient",
    nextSend: "/v2/patient/next-send",
    updateNextSend: "/v2/patient/next-send/update",
    updateBillingSchedule: "/v2/patient/updateBillingSchedule",
    uploadDocument: "/v2/patient/document-upload",
    fetchDocuments: "v2/patient/fetch/document/:serialNumber",
    fetchDocumentSignedURL: "v2/patient/fetch/document-signed-url",
    fetchMedications: "/v2/patient/medication/:patientId",
    addOrUpdateMedication: "/v2/patient/medication",
    deleteMedication: "/v2/patient/medication/:patientId/:medicationId",
    fetchByPatientId: "/v2/patient/profile/:patientId",
    fetchDeviceAlertList: "/v2/patient/device-alert/list",
    addPatientNote: "/v2/patient/notes",
    getPatientNotesHistory: "/v2/patient/notes/:patientId",
    updateAnticoaStatus: "/v2/patient/anticoag-status/:patientId",
    findPatientByName: "/v2/patient/recordsByName",
    findPatientRecordsByNameOrDobOrEvokeId:
      "/v2/patient/recordsByNameOrDobOrEvokeId",
    updatePatientHistory: "/v2/patient/information/:patientId",
    batteryInformation: "/v2/patient/battery-information/:patientId",
    downloadDisconnectedMonitors: "/v2/patient/disconnected-monitors",
    downloadNoShowMasterList: "/v2/patient/no-show-master-list",
    formSettings: "/v2/patient/form-settings",
    sendLetter: "/v2/patient/send-letter/:serialNumber",
    leadInformation: "/v2/patient/lead-information/:patientId",
    addNewDevice: "/v2/patient/new-device/:id",
    createPatient: "/v2/patient/create/:serialNumber",
    subscribeSetting: "/v2/patient/subscribe-setting/:patientId",
    getSubscriptionPauseHistory:
      "/v2/patient/:patientId/subscription-pause-history",
    downloadBillingHistory: "/v2/patient/billing-history",
    downloadReminderPatients: "/v2/patient/download-reminder-patients",
    patientInformation: "/v2/patient/patient-information/:serialNumber",
    patientsByEvokeId: "/v2/patient/patients-by-evoke-id",
    mergePatients: "/v2/patient/merge-patients",
    getNonCompliantPatients: "/v2/patient/non-compliant-patient/reminders",
    getPatientReminderHistory:
      "/v2/patient/non-compliant-patient/:patientId/reminder-history",
    downloadOverduePatients: "/v2/patient/no-show-patients/download/overdue",
    getNonEnrolledPatients: "/v2/patient/non-enrolled-patients",
    enrollNonEnrolledPatient: "/v2/patient/non-enrolled-patients/enroll",
    liveCall: "/v2/patient/:patientId/live-call",
    updateLaaoDevice: "/v2/patient/laao-device/:patientId",
    updateIDTF: "/v2/patient/idtf/:patientId",
    patientAdvisory: "/v2/patient/update-advisory",
    updateBenchmarkId: "/v2/patient/update-benchmark-id/:patientId",
    searchPatients: "/v2/patient/search-patient",
    letterNextSend: "/v2/patient/letter-next-send",
    updateSelfPayStatus: "/v2/patient/:patientId/self-pay",
    updatePreAuthStatus: "/v2/patient/:patientId/pre-auth",
  },
  dashboard: {
    patientAnalytic: `/v2/dashboard/patients`,
    manufacturerList: "/v2/dashboard/manufacturer-list",
    transmissionAnalytic: `/v2/dashboard/transmissions`,
    billableIntervalAnalytic: `/v2/dashboard/billable-intervals`,
    implantElectronicDevice: "/v2/dashboard/electronic-device",
    surgeryTypes: "/v2/dashboard/surgery-types",
    doctors: "/v2/dashboard/doctors",
    doctorsReport: "/v2/dashboard/doctors/download-report",
    revenueAnalytic: "/v2/dashboard/revenue",
    accountAnalytic: "/v2/dashboard/account-analytics",
    patientComplianceAnalytic: "/v2/dashboard/patient-compliance-analytics",
    accounts: "/v2/dashboard/accounts",
    deviceTypePatients: "/v2/device-types/patient-count",
  },
  billingAmount: {
    billingAmounts: "/v2/billing-amount",
    billingAmountById: "/v2/billing-amount/:id",
  },
  benchmarkBilling: {
    search: "/v2/benchmark-billing/search",
  },
  mfa: {
    updateStatus: "/v2/mfa/update-status",
    validateEnableOTP: "v2/mfa/otp/validate-email",
    validateLoginOTP: "v2/mfa/otp/validate-login",
    requestOTP: "v2/mfa/otp/request",
    getMFAStatus: "v2/mfa/status",
  },
  auth: {
    login: "/login",
    cognitoLogin: "/oauth/cognito",
    profile: "/v2/user/profile",
    verifyToken: "/v2/user/validate-token",
    resetPassword: "/v2/user/reset-password",
    refreshToken: "/v2/user/refresh-token",
    logout: "/logout",
  },
  rpm: {
    clinii: {
      fetchRpmCliniiView: "/v2/rpm/clinii/signin-portal",
    },
    fetchCoverPage: "/v2/rpm/download-report/:patientId",
    fetchRpmPatientBilling: "/v2/rpm/rpm-patient-billing/:patientId",
  },
  letter_templates: {
    fetchLetterTemplates: "/v2/letter-template/:patientId",
    generateLetterTemplate: "/v2/letter-template/generate",
    saveLetterTemplate: "/v2/letter-template/save",
    getLetterNextSend: "/v2/letter-template/letter-next-send",
    fetchAllLetterTemplates: "/v2/letter-template", // old
    createLetterTemplate: "/v2/letter-template/create",
    letterTemplateById: "/v2/letter-template/:templateId",
    updateLetterTemplate: "/v2/letter-template/update/:templateId",
    updateLetterTemplateStatus: "/v2/letter-template/update-status",
    fetchAllLetterContentTemplate:
      "/v2/letter-template/letter-content-templates/fetch",
  },
  noShowLetter: {
    fetchNoShowLetters: "/v2/no-show-letter/:patientId",
    generateNoShowLetter: "/v2/no-show-letter/generate",
    sendNoShowEmail: "/v2/no-show-letter/send",
  },
  manufacturer: {
    fetchManufacturers: "/v2/manufacturers",
    manufacturerAccounts: "/v2/manufacturer-account",
    manufacturerAccountById: "/v2/manufacturer-account/:id",
    activeManufacturerAccounts: "/v2/manufacturer-account/active",
    manufacturerAccountStatusById: "/v2/manufacturer-account/toggle-status/:id",
    manufacturerAccountChangePassword:
      "/v2/manufacturer-account/change-password/:id",
  },
  deviceTypes: {
    fetchDeviceTypes: "/v2/device-types",
  },
  manualUpload: {
    uploadReport: "/v2/transmission/user-report",
    inOfficeUpload: "/v2/in-office/upload",
    findSimilarPatientsFromInOfficeFile: "/v2/in-office/similar-patients",
    extractReportData: "/v2/manual-upload/extract-report-data",
  },
  archivedReports: {
    list: "/v2/archived-report/list",
    downloadList: "/v2/archived-report/download-list",
    downloadReports: "/v2/archived-report/download-reports",
  },
  accounts: {
    preferences: "/accounts/preferences",
  },
  notification: {
    preference: "/v2/alert-configurations",
    preferenceByAccount: "/v2/alert-configurations/:account",
    list: "/v2/notifications",
    markAllRead: "/v2/notifications/mark-all-read",
    markRead: "/v2/notifications/:id/read",
  },
  users: {
    users: "/admin/users",
    switchRole: "/v2/user/switch-role/:userId",
  },
  userActivityLog: {
    transmissionReportLogByUserId: "/v2/user-activity-log",
    transmissionProgressReportByUserId: "/v2/user-activity-log/progress-report",
    topUserProgressReport: "/v2/user-activity-log/top-users-progress-report",
    userTransmissionProgressAnalytics:
      "/v2/user-activity-log/user-transmission-progress-analytics",
    userTransmissionProgressReport:
      "/v2/user-activity-log/user-transmission-progress-report",
    transmissionProgressAnalyticsUsers:
      "v2/user-activity-log/user-transmission-progress-analytics/users",
  },
  adt: {
    downloadAdt: "/v2/adt/download/:filename",
  },
  hl7Job: {
    processBulkHl7Jobs: "/hl7job/v2/processBulkHl7Jobs",
    fetchHL7Jobs: "/v2/hl7job",
  },
  task: {
    getActiveTasks: "/tasks",
    getArchivedTasks: "/tasks/archived",
    getAutomatedSchedulingTasks: "/tasks/automated/scheduling",
    getAuditedTasks: "/tasks/audited",
    getAuditedArchivedTasks: "/tasks/audited/archived",
    archiveTasks: "/tasks/archive",
    createTask: "/task/",
    updateTask: "/task/:taskId",
    requestNoteDeletion:
      "/v2/patient-note-deletion-requests/notes/:patientId/:noteId",
    getPendingApprovals: "/v2/patient-note-deletion-requests/pending-approvals",
    approveOrDeclineStatus:
      "/v2/patient-note-deletion-requests/pending-approvals/:requestId/:status",
  },
  quickTextTemplate: {
    getTemplates: "/v2/quick-text-templates",
    createTemplate: "/v2/quick-text-templates/add",
    updateTemplate: "/v2/quick-text-templates/:templateId",
    deleteTemplate: "/v2/quick-text-templates/:templateId",
  },
  liveCallTasks: {
    getLiveCallTasks: "/v2/live-call-tasks",
    markComplete: "/v2/live-call-tasks/:taskId/mark-complete",
  },
  cognito: {
    verify: "/cognito/verify",
    authUrl: "/cognito/auth-url/:provider",
  },
  alertProtocol: {
    list: "/v2/alert-protocol",
    create: "/v2/alert-protocol",
    update: "/v2/alert-protocol/:protocolId",
    delete: "/v2/alert-protocol/:protocolId",
  },
  accountDocuments: {
    availability: "/v2/account-documents/:accountId",
    document: "/v2/account-documents/:accountId/:documentType",
  },
};

export default endpoints;
